import BaseModel from './BaseModel';
import Student from './Student';

/** Class representing an user. */
class User extends BaseModel {
    constructor(properties) {
        super(properties);

        if (('student' in this) && this.student?.id)
            this.student = new Student(this.student);

        if ('children' in this)
            this.children = (this.children || []).map(child => new Student(child));
    }

    userRole       = () => User.ROLE_USER;
    teacherRole    = () => User.ROLE_TEACHER;
    adminRole      = () => User.ROLE_ADMIN;
    superAdminRole = () => User.ROLE_SUPER_ADMIN;

    isUser       = () => this.isAdmin() || this.role === User.ROLE_USER;
    isTeacher    = () => this.role === User.ROLE_TEACHER;
    isAdmin      = () => this.isSuperAdmin() || this.role === User.ROLE_ADMIN;
    isSuperAdmin = () => this.role === User.ROLE_SUPER_ADMIN;

    // returns true if user role allows him to have the given role
    hasRole = (role) => {
        return {
            [User.ROLE_SUPER_ADMIN]: this.isSuperAdmin(),
            [User.ROLE_ADMIN]: this.isAdmin(),
            [User.ROLE_TEACHER]: this.isTeacher(),
            [User.ROLE_USER]: this.isUser()
        }[role];
    }
}

User.GENDER_DEFAULT = '?';
User.GENDER_FEMALE  = 'F';
User.GENDER_MALE    = 'M';

User.ROLE_SUPER_ADMIN = 'super_admin';
User.ROLE_ADMIN       = 'admin';
User.ROLE_TEACHER     = 'teacher';
User.ROLE_USER        = 'user';

User.genders = () => {
    return [
        User.GENDER_DEFAULT,
        User.GENDER_FEMALE,
        User.GENDER_MALE,
    ];
};

User.roles = () => {
    return [
        User.ROLE_SUPER_ADMIN,
        User.ROLE_ADMIN,
        User.ROLE_TEACHER,
        User.ROLE_USER,
    ];
};

export default User;
